import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "./../../redux/actions/menuActions";
import leftMenu from "./Menu";
import _ from "lodash";
import AuthRender from "../../containers/AuthRender";
import { SERVICES } from "../../configs/constants";
import { Route, Redirect } from "react-router";
class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftIndex("home");
    this.props.setMenuLeftItemIndex("");
    this.props.setMenuLeftContent(leftMenu);
  }
  render() {
    return (
      <div className="p-landing">
        <AuthRender minRole={1}>
          <Redirect to="kpis" />
        </AuthRender>
        <AuthRender service={SERVICES.Secto}>
          <Redirect to="secteurs" />
        </AuthRender>
        <AuthRender service={SERVICES.Modele}>
          <Redirect to="modeles" />
        </AuthRender>
        <AuthRender minRole={1}>
          <Redirect to="metier" />
        </AuthRender>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || 0;
  const currentUser = state.userInfos || {};
  const currentUserClients = currentUser.clients || [];
  const currentUserClient = _.find(currentUserClients, { id: currentClientId }) || {};
  const currentUserClientServices = currentUserClient.services || [];

  return {
    currentServices: currentUserClientServices,
    currentRoleId: currentUser.role_id || 100
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// src/pages/imports/Home.js